import React from 'react';
import SettingsProfile from "@/features/settings-profile/SettingsProfile";

const SettingsProfilePage = () => {
  return <SettingsProfile />;
};

export default SettingsProfilePage;
